<template>
    <div>
        <slot v-if="isActive"></slot>
    </div>
</template>

<script>
    export default {
        name: 'tab',
        props: ['title'],
        data() {
            return {
                isActive: false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/controls/Tab.vue